// extracted by mini-css-extract-plugin
module.exports = {"block":"styles-module__block___+9JVG","show":"styles-module__show___1nIbP","danger":"styles-module__danger___sO7KD","success":"styles-module__success___YBLDP"};